import { render, staticRenderFns } from "./ItemBlue.vue?vue&type=template&id=6e2868fd&scoped=true&"
import script from "./ItemBlue.vue?vue&type=script&lang=js&"
export * from "./ItemBlue.vue?vue&type=script&lang=js&"
import style0 from "./ItemBlue.vue?vue&type=style&index=0&id=6e2868fd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2868fd",
  null
  
)

export default component.exports